module.exports = __webpack_public_path__ + "static/img/CQHK.185acf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/CQHK.png
// module id = BRqd
// module chunks = 34